import React, { useState, useEffect, useRef } from "react";
import "./Admin.css";
import Heading from "./Heading";
import { RiUser3Fill } from "react-icons/ri";
import { FaUserTie, FaBackspace } from "react-icons/fa";
import {
  FaUserXmark,
  FaUserCheck,
  FaUserGear,
  FaUserPen,
  FaUserPlus,
} from "react-icons/fa6";
import { LuNotebookPen } from "react-icons/lu";

// import { LuNotebookPen } from "react-icons/lu";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { motion } from "framer-motion";
import { GoTriangleDown } from "react-icons/go";
import "./Reports.css";

function Admin() {
  const [error, seterror] = useState({
    confirmpassword: "",
  });

  const [listingValues, setListingValues] = useState({
    client_id: "",
    client: "",
    state: "",
    year: "",
    month: "",
    division: "",
  });

  const [selectedTable, setSelectedTable] = useState(null);

  const [userupdate, setUserupdate] = useState({
    hr: "",
    username: "",
  });

  const [clientupdate, setclientupdate] = useState({
    client: "",
    username: "",
  });

  const [active, setactive] = useState({
    user: "",
    client: "",
  });
  const [inactive, setinactive] = useState({
    user: "",
    client: "",
  });

  const [issubmitted, setissubmitted] = useState(false);
  const [showAdditionalComponent, setShowAdditionalComponent] = useState(false);
  const [ClientDashboard, setClientDashboard] = useState(false);
  const [UserDashboard, setUserDashboard] = useState(false);
  const [reports, setreports] = useState(false);
  // const [isMain3PopupOpen, setIsMain3PopupOpen] = useState(false);
  const [popupvalue, setPopupvalue] = useState("");

  const [client, setclient] = useState([]);
  const [hruser, sethruser] = useState([]);

  const [inactiveclient, setinactiveclient] = useState([]);
  const [inactiveuser, setinactiveuser] = useState([]);

  const [clientdetails, setClientdetails] = useState({
    clientcode: "",
    clientname: "",
    username: "",
    password: "",
    state: "",
  });

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  const menuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [results, setresults] = useState({
    year: "",
    month: "",
  });
  const [userpassword, setuserpassword] = useState({
    username: "",
    newpassword: "",
    confirmpassword: "",
  });
  const [clientpassword, setclientpassword] = useState({
    username: "",
    newpassword: "",
    confirmpassword: "",
  });
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Array.from({ length: 5 }, (_, i) => 2024 + i);

  const handleSubmit = (event) => {
    event.preventDefault();
    setissubmitted(true);
    setShowAdditionalComponent(true);
    setSelectedTable("register");
  };

  // user create
  const handleCreate = async (type) => {
    if (
      clientdetails.username.trim() &&
      clientdetails.password.trim() &&
      (clientdetails.state || type === "HR")
    ) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/createuser.php`;
      const formData = new FormData();
      formData.append("clientname", clientdetails.clientname);
      formData.append("username", clientdetails.username);
      formData.append("password", clientdetails.password);
      formData.append("role", type);
      if (type === "client") {
        formData.append("state", clientdetails.state);
        formData.append("clientcode", clientdetails.clientcode);
      } else {
        formData.append("state", "");
        formData.append("clientcode", "");
      }
      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setClientdetails({
            username: "",
            password: "",
          });
          setPopupvalue("");
          setClientDashboard(false);
          setUserDashboard(false);
          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("please enter all the fields");
    }
  };

  // change password
  const handlechangepassword = (value, formData) => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/changepassword.php`;
    const response = fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (value === "user") {
          setPopupvalue("");
          setUserDashboard(false);
          setuserpassword({
            username: "",
            newpassword: "",
            confirmpassword: "",
          });
        } else if (value === "client") {
          setPopupvalue("");
          setClientDashboard(false);
          setclientpassword({
            username: "",
            newpassword: "",
            confirmpassword: "",
          });
        }
        alert(data.message);
      })
      .catch((error) => {
        console.log("Error with POST request:", error);
      });
  };
  const handleuserpassword = () => {
    if (
      userpassword.username &&
      userpassword.newpassword.trim() &&
      userpassword.confirmpassword === userpassword.newpassword
    ) {
      const formData = new FormData();
      formData.append("id", userpassword?.username);
      formData.append("password", userpassword?.newpassword);
      handlechangepassword("user", formData);
    } else {
      if (userpassword.confirmpassword != userpassword.newpassword) {
        seterror((prev) => ({
          ...prev,
          confirmpassword: "New password and confirm password is not same!",
        }));
      } else {
        alert("please enter both ");
      }
    }
  };
  const handleclientpassword = () => {
    if (
      clientpassword.username &&
      clientpassword.newpassword.trim() &&
      clientpassword.confirmpassword === clientpassword.newpassword
    ) {
      const formData = new FormData();
      formData.append("id", clientpassword?.username);
      formData.append("password", clientpassword?.newpassword);
      handlechangepassword("client", formData);
    } else {
      if (clientpassword.confirmpassword != clientpassword.newpassword) {
        seterror((prev) => ({
          ...prev,
          confirmpassword: "New password and confirm password is not same!",
        }));
      } else {
        alert("please enter both ");
      }
    }
  };

  // update user
  const handleUserUpdate = () => {
    if (userupdate.hr && userupdate.username.trim()) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/updateuserdetail.php`;
      const formData = new FormData();
      formData.append("id", userupdate?.hr);
      formData.append("username", userupdate?.username);
      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setPopupvalue("");
          // setIsMain3PopupOpen(false);
          setUserupdate({
            hr: "",
            username: "",
          });
          getuserlist("hr");
          setUserDashboard(false);
          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("please enter both username and hr");
    }
  };

  const handleclientUpdate = () => {
    if (clientupdate.client && clientupdate.username.trim()) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/updateuserdetail.php`;
      const formData = new FormData();
      formData.append("id", clientupdate?.client);
      formData.append("username", clientupdate?.username);
      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setPopupvalue("");
          // setIsMain3PopupOpen(false)
          setclientupdate({
            client: "",
            username: "",
          });
          setClientDashboard(false);
          getuserlist("client");
          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("please enter both username and hr");
    }
  };

  const handleactive = () => {
    if (active?.user || active?.client) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/userinactive.php`;
      const formData = new FormData();

      // Properly assigning the ID
      const id = active.user || active.client;
      formData.append("id", id); // Fixed issue here

      fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json()) // Simplified the response handling
        .then((data) => {
          setPopupvalue("");
          setactive({
            user: "",
            client: "",
          });
          setinactive({
            user: "",
            client: "",
          });
          getinactivelist("hr");
          getuserlist("hr");
          getinactivelist("client");
          getuserlist("client");
          setClientDashboard(false);
          setUserDashboard(false);
          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("Please Select The ID");
    }
  };

  const handleinactive = () => {
    if (inactive?.user || inactive?.client) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/useractive.php`;
      const formData = new FormData();
      const id = inactive.user || inactive.client;
      formData.append("id", id);
      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setPopupvalue("");
          // setIsMain3PopupOpen(false)
          setactive({
            user: "",
            client: "",
          });
          setinactive({
            user: "",
            client: "",
          });
          getinactivelist("hr");
          getuserlist("hr");
          getinactivelist("client");
          getuserlist("client");
          setClientDashboard(false);
          setUserDashboard(false);
          alert(data.message);
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    } else {
      alert("Please Select The ID");
    }
  };

  // get user details
  const getuserlist = (role) => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getusers.php`;
    const formData = new FormData();
    formData.append("role", role);
    const response = fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (role === "hr") {
          sethruser(data?.data);
        } else if (role === "client") {
          setclient(data?.data);
        } else {
        }
      })
      .catch((error) => {
        console.log("Error with POST request:", error);
      });
  };

  const getinactivelist = (role) => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getusersinactive.php`;
    const formData = new FormData();
    formData.append("role", role);
    const response = fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (role === "hr") {
          setinactiveuser(data?.data);
        } else if (role === "client") {
          setinactiveclient(data?.data);
        } else {
        }
      })
      .catch((error) => {
        console.log("Error with POST request:", error);
      });
  };

  useEffect(() => {
    getuserlist("hr");
    getuserlist("client");
    getinactivelist("hr");
    getinactivelist("client");
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        // setaddactpopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

  // const [Reports, setReports] = useState({ year: "", month: "" });
  const [Uploadclient, setUploadClient] = useState([]);
  const [Upload1client, setUpload1Client] = useState([]);
  const [NotUploadclient, setNotUploadClient] = useState([]);
  const [Results, setResults] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [isOpen, setIsOpen] = useState(" ");
  const [isOpen1, setIsOpen1] = useState(false);
  const COLORS = ["#0088FE", "#00C49F"];

  const handleTrack = async () => {
    await fetchNotUploadedClients();
    await fetchUploadedClients();
  };

  const fetchNotUploadedClients = async () => {
    if (!results.year || !results.month) {
      alert("Please Select Both Year and Month");
      return;
    }

    const formData = new FormData();
    formData.append("year", results?.year);
    formData.append("month", results?.month);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/notupload.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      setNotUploadClient(data.data || []);

      // Only update pie chart data from notupload API response
      if (data.total_count !== undefined) {
        setChartData([
          { name: "Pending", value: data.pending_count },
          { name: "Completed", value: data.com_count },
        ]);
        setResults(true);
      }
    } catch (error) {
      console.error("Error fetching not uploaded clients:", error);
      setNotUploadClient([]);
    }
  };

  const fetchUploadedClients = async () => {
    if (!results.year || !results.month) {
      alert("Please Select Both Year and Month");
      return;
    }

    const formData = new FormData();
    formData.append("year", results?.year);
    formData.append("month", results?.month);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/upload.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      setUploadClient(data.file_details || []);
      setUpload1Client(data.client_name || []);
      // Do NOT update chartData here so the pie chart remains from notupload API
    } catch (error) {
      console.error("Error fetching uploaded clients:", error);
      setUploadClient([]);
    }
  };

  const crthandledownload = async (type) => {
    if (!results.year || !results.month) {
      alert("Please Select Both Year and Month");
      return;
    }

    const url = `${process.env.REACT_APP_BASEURL}/apis/up_reportdownload.php?year=${results.year}&month=${results.month}&type=${type}`;

    try {
      const response = await fetch(url, { method: "GET" });
      const blob = await response.blob();

      const contentType = response.headers.get("Content-Type");
      const extension = type === "pdf" ? "pdf" : "csv"; // assuming server returns csv for Excel

      if (!response.ok || !contentType.includes(extension)) {
        const text = await response.text();
        console.error("Unexpected response:", text);
        alert("No data or wrong format returned.");
        return;
      }

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute(
        "download",
        `report-${results.year}-${results.month}.${extension}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
      alert("There was an error downloading the report.");
    }
  };

  const handlependingdownload = async (type) => {
    if (!results.year || !results.month) {
      alert("Please Select Both Year and Month");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/not_reportdownload.php?year=${results.year}&month=${results.month}&type=${type}`,
        {
          method: "GET",
        }
      );

      const contentType = response.headers.get("Content-Type");
      const extension = type === "pdf" ? "pdf" : "csv";

      if (!response.ok || !contentType.includes(extension)) {
        const text = await response.text();
        console.error("Unexpected response:", text);
        alert("No data or wrong format returned.");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `report-${results.year}-${results.month}.${extension}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
      alert("There was an error downloading the report.");
    }
  };

  const handlecompletedownload = async (type) => {
    if (!results.year || !results.month) {
      alert("Please Select Both Year and Month");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/up_reportdownload.php?year=${results.year}&month=${results.month}&type=${type}`,
        {
          method: "GET",
        }
      );

      const contentType = response.headers.get("Content-Type");
      const extension = type === "pdf" ? "pdf" : "csv";

      if (!response.ok || !contentType.includes(extension)) {
        const text = await response.text();
        console.error("Unexpected response:", text);
        alert("No data or wrong format returned.");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `report-${results.year}-${results.month}.${extension}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
      alert("There was an error downloading the report.");
    }
  };

  const [expandedClientIndex, setExpandedClientIndex] = useState(null);

  // Simulated API call per client (replace this with actual if needed)
  const getClientFiles = async (clientname) => {
    // Optional: Filter existing Uploadclient list or call backend if needed
    return Uploadclient.filter(
      (f) => f.client_name === Upload1client.client_name
    );
  };

  return (
    <div>
      <div className="admin-container1">
        {/* #HR  */}
        {userDetails.role === "admin" || hruser.user_id === "hrm" ? (
          <div className="table-container">
            <table className="fixed-header-table">
              <thead>
                <tr>
                  <td colSpan={2} className="reg">
                    <h3>HR Login</h3>
                  </td>
                </tr>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {hruser.map((row) => (
                  <tr key={row.user_id}>
                    <td>{row.user_id}</td>
                    <td>{row.client_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}

        {/* #Form  */}
        <div>
          <form className="admin-form" onSubmit={handleSubmit}>
            <div className="admin-container">
              {/* Client list*/}
              {userDetails.role !== "client" ? (
                <div className="form-group">
                  <label htmlFor="client">Client</label>
                  <select
                    id="client"
                    className="form-control"
                    value={listingValues?.client}
                    onChange={(e) => {
                      const selectedClient = client.find(
                        (row) => row.username === e.target.value
                      );
                      setListingValues((prevUser) => ({
                        ...prevUser,
                        client_id: selectedClient?.id,
                        client: selectedClient?.username,
                      }));
                    }}
                    required
                  >
                    <option value={""} disabled>
                      Select Client
                    </option>
                    {client.map((row) => {
                      return (
                        <option value={row.username}>{row.username}</option>
                      );
                    })}
                  </select>
                </div>
              ) : null}

              {/* Year */}
              <div className="form-group">
                <label htmlFor="year">Year</label>
                <select
                  id="year"
                  className="form-control"
                  value={listingValues?.year}
                  onChange={(e) =>
                    setListingValues((prevUser) => ({
                      ...prevUser,
                      year: e.target.value,
                    }))
                  }
                  required
                >
                  <option value="" disabled>
                    Year
                  </option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              {/* Month */}
              <div className="form-group">
                <label htmlFor="month">Month</label>
                <select
                  id="month"
                  className="form-control"
                  value={listingValues?.month}
                  onChange={(e) =>
                    setListingValues((prevUser) => ({
                      ...prevUser,
                      month: e.target.value,
                    }))
                  }
                  required
                >
                  <option value="" disabled>
                    Month
                  </option>
                  {months.map((month, index) => (
                    <option key={index} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>

              {/* Division */}
              <div className="form-group">
                <label htmlFor="division">Division</label>
                <select
                  id="division"
                  className="form-control"
                  value={listingValues?.division}
                  onChange={(e) =>
                    setListingValues((prevUser) => ({
                      ...prevUser,
                      division: e.target.value,
                    }))
                  }
                  required
                >
                  <option value="" disabled>
                    Division
                  </option>
                  <option value="No_Division">No Division</option>
                  <option value="Division-1">Division-1</option>
                  <option value="Division-2">Division-2</option>
                  <option value="Division-3">Division-3</option>
                  <option value="Division-4">Division-4</option>
                </select>
              </div>
            </div>
            <button type="submit" className="bttn">
              Submit
            </button>
          </form>
          <div>
            {issubmitted && (
              <div className="fo">
                <h3>Selected Data:</h3>

                <div className="form-data-display">
                  {userDetails.role != "client" && (
                    <p>
                      <strong>Client:</strong> {listingValues.client}
                    </p>
                  )}
                  {userDetails.role !== "client" && (
                    <p>
                      <strong>State:</strong>{" "}
                      {
                        client.find((c) => c.username === listingValues.client)
                          ?.state
                      }
                    </p>
                  )}

                  {/* {userDetails.role != 'client' && (<p><strong>State:</strong> {client?.state}</p>)} */}
                  <p>
                    <strong>Year:</strong> {listingValues.year}
                  </p>
                  <p>
                    <strong>Month:</strong> {listingValues.month}
                  </p>
                  <p>
                    <strong>Division:</strong> {listingValues.division}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* #menu  */}
        {userDetails.role === "admin" ? (
          <div className="menu">
            <div className="menu-dropdown">
              <button
                className="menu-button"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                Menu
              </button>
              {isMenuOpen && (
                <div className="menu-box" ref={menuRef}>
                  <button
                    className="menu-item"
                    onClick={() => setClientDashboard(true)}
                  >
                    <FaUserTie /> CLIENT DASHBOARD
                  </button>
                  <button
                    className="menu-item"
                    onClick={() => setUserDashboard(true)}
                  >
                    <RiUser3Fill /> USER DASHBOARD
                  </button>
                  <button
                    className="menu-item"
                    onClick={() => setreports(true)}
                  >
                    <LuNotebookPen /> REPORTS
                  </button>
                </div>
              )}
            </div>
            {/* CLIENT */}
            {ClientDashboard && (
              <div
                className="popup-overlay"
                onClick={() => setClientDashboard(false)}
              >
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <h2 className="HeaderNew">
                    <FaUserTie /> CLIENT DASHBOARD
                  </h2>

                  <div className="full-logo">
                    <div className="icon-container">
                      <div className="newlog">
                        <FaUserPlus
                          onClick={() => setPopupvalue("AddClient")}
                        />
                      </div>
                      <div className="label">CREATE NEW</div>
                    </div>

                    <div>
                      <div className="Vline"></div>
                    </div>
                    <div>
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserPen
                            onClick={() => setPopupvalue("clientpassword")}
                          />
                        </div>
                        <div className="label">CHANGE PASSWORD</div>
                      </div>
                      <br />
                      <br />
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserCheck
                            onClick={() => setPopupvalue("clientActive")}
                          />
                        </div>
                        <div className="label">ACTIVE CLIENT</div>
                      </div>
                    </div>

                    <div>
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserGear
                            onClick={() => setPopupvalue("clientupdate")}
                          />
                        </div>
                        <div className="label">UPDATE CLIENT</div>
                      </div>

                      <br />
                      <br />

                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserXmark
                            onClick={() => setPopupvalue("clientinactive")}
                          />
                        </div>
                        <div className="label">INACTIVE CLIENT</div>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div>
                    <button
                      className="close-btn"
                      onClick={() => setClientDashboard(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "AddClient" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">Client Code: </span>
                      <input
                        type="text"
                        value={clientdetails.clientcode}
                        placeholder="Enter Client Code"
                        required
                        onChange={(e) =>
                          setClientdetails((prevUser) => ({
                            ...prevUser,
                            clientcode: e.target.value,
                          }))
                        }
                        className="Name"
                      />

                      <span className="cname">Client Name: </span>
                      <input
                        type="text"
                        value={clientdetails.clientname}
                        placeholder="Enter Client Name"
                        required
                        onChange={(e) =>
                          setClientdetails((prevUser) => ({
                            ...prevUser,
                            clientname: e.target.value,
                          }))
                        }
                        className="Name"
                      />

                      <span className="cname">Username: </span>
                      <input
                        type="text"
                        value={clientdetails.username}
                        placeholder="Enter Username"
                        required
                        onChange={(e) =>
                          setClientdetails((prevUser) => ({
                            ...prevUser,
                            username: e.target.value,
                          }))
                        }
                        className="Name"
                      />
                      <span className="cname">Password: </span>
                      <input
                        type="password"
                        value={clientdetails.password}
                        placeholder="Enter Password"
                        required
                        onChange={(e) =>
                          setClientdetails((prevUser) => ({
                            ...prevUser,
                            password: e.target.value,
                          }))
                        }
                        className="Name"
                      />
                      <span className="cname">State: </span>
                      <select
                        required
                        className="ds1"
                        onChange={(e) =>
                          setClientdetails((prev) => ({
                            ...prev,
                            state: e.target.value,
                          }))
                        }
                        value={clientdetails.state}
                      >
                        {/* 
                        <option value="" default className='do2'>
                          Select State
                        </option> */}
                        {/* <option value="tamil_nadu">Tamil Nadu</option>
                        <option value="maharashtra">Maharashtra</option>
                        <option value="odisha">Odisha</option>
                        <option value="karnataka">Karnataka</option> */}

                        <option value="" disabled>
                          Select State
                        </option>
                        <option value="andhra_pradesh">Andhra Pradesh</option>
                        <option value="arunachal_pradesh">
                          Arunachal Pradesh
                        </option>
                        <option value="assam">Assam</option>
                        <option value="bihar">Bihar</option>
                        <option value="chhattisgarh">Chhattisgarh</option>
                        <option value="delhi">Delhi</option>
                        <option value="goa">Goa</option>
                        <option value="gujarat">Gujarat</option>
                        <option value="haryana">Haryana</option>
                        <option value="himachal_pradesh">
                          Himachal Pradesh
                        </option>
                        <option value="jharkhand">Jharkhand</option>
                        <option value="karnataka">Karnataka</option>
                        <option value="kerala">Kerala</option>
                        <option value="madhya_pradesh">Madhya Pradesh</option>
                        <option value="maharashtra">Maharashtra</option>
                        <option value="manipur">Manipur</option>
                        <option value="meghalaya">Meghalaya</option>
                        <option value="mizoram">Mizoram</option>
                        <option value="nagaland">Nagaland</option>
                        <option value="odisha">Odisha</option>
                        <option value="punjab">Punjab</option>
                        <option value="rajasthan">Rajasthan</option>
                        <option value="sikkim">Sikkim</option>
                        <option value="tamil_nadu">Tamil Nadu</option>
                        <option value="telangana">Telangana</option>
                        <option value="tripura">Tripura</option>
                        <option value="uttar_pradesh">Uttar Pradesh</option>
                        <option value="uttarakhand">Uttarakhand</option>
                        <option value="west_bengal">West Bengal</option>
                      </select>
                      <button
                        onClick={() => handleCreate("client")}
                        className="create"
                      >
                        Create
                      </button>
                    </div>
                  </div>
                  {/* <button className="close-btn" onClick={() => setIsNestedCPopupOpen(false)}>Close</button> */}
                </div>
              </div>
            )}
            {popupvalue === "clientpassword" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">Client Name: </span>

                      <select
                        className="ds1"
                        value={clientpassword.username}
                        onChange={(e) =>
                          setclientpassword((prevUser) => ({
                            ...prevUser,
                            username: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled selected>
                          Select Client
                        </option>
                        {client.map((row) => {
                          return (
                            <option value={row?.id}>{row?.username}</option>
                          );
                        })}
                      </select>

                      <span className="cname">New Password: </span>
                      <input
                        type="password"
                        value={clientpassword.newpassword}
                        placeholder="New password"
                        required
                        onChange={(e) =>
                          setclientpassword((prevUser) => ({
                            ...prevUser,
                            newpassword: e.target.value,
                          }))
                        }
                        className="Name"
                      />
                      <span className="cname">Confirm Password: </span>
                      <input
                        type="password"
                        value={clientpassword.confirmpassword}
                        placeholder="Confirm Password"
                        required
                        onChange={(e) => {
                          setclientpassword((prev) => ({
                            ...prev,
                            confirmpassword: e.target.value,
                          }));
                          if (clientpassword.newpassword === e.target.value) {
                            seterror((prev) => ({
                              ...prev,
                              confirmpassword: "",
                            }));
                          }
                        }}
                        className="Name"
                      />
                      {error.confirmpassword ? (
                        <p>{error.confirmpassword} </p>
                      ) : null}

                      <button
                        onClick={() => handleclientpassword()}
                        className="create"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "clientupdate" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">Client`s Name: </span>

                      <select
                        value={clientupdate?.client}
                        className="ds1"
                        onChange={(e) =>
                          setclientupdate((prev) => ({
                            ...prev,
                            client: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled selected>
                          Choose Client
                        </option>
                        {client.map((row) => {
                          return (
                            <option value={row?.id}>{row?.username}</option>
                          );
                        })}
                      </select>

                      <span className="cname">User Name: </span>
                      <input
                        type="text"
                        value={clientupdate?.username}
                        placeholder="Enter Name"
                        required
                        onChange={(e) =>
                          setclientupdate((prev) => ({
                            ...prev,
                            username: e.target.value,
                          }))
                        }
                        className="Name"
                      />

                      <button onClick={handleclientUpdate} className="create">
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "clientActive" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">Client: </span>

                      <select
                        value={active?.client}
                        className="ds1"
                        onChange={(e) =>
                          setactive((prev) => ({
                            ...prev,
                            client: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled>
                          Choose Client
                        </option>
                        {client.map((row) => (
                          <option key={row?.id} value={row?.id}>
                            {row?.username}
                          </option>
                        ))}
                      </select>

                      {/* <select value={userupdate?.hr} className='ds1' onChange={(e) => setUserupdate(prev => ({ ...prev, hr: e.target.value }))}>
                        <option value="" disabled selected>Choose HR</option>
                        {
                          hruser.map(row => {
                            return <option value={row?.id} >{row?.user_id}</option>
                          })
                        }
                      </select> */}

                      {/* <span className='cname'>User Name: </span>
                      <input
                        type="text"
                        value={userupdate?.username}
                        placeholder="Enter Name"
                        required
                        onChange={(e) => setUserupdate(prev => ({ ...prev, username: e.target.value }))}
                        className='Name'
                      /> */}

                      <button onClick={handleactive} className="create">
                        Inactive
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "clientinactive" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>

                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">Client: </span>
                      <select
                        value={inactive?.client}
                        className="ds1"
                        onChange={(e) =>
                          setinactive((prev) => ({
                            ...prev,
                            client: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled>
                          Choose Client
                        </option>
                        {Array.isArray(inactiveclient) &&
                        inactiveclient.length > 0 ? (
                          inactiveclient.map((row) => (
                            <option key={row?.id} value={row?.id}>
                              {row?.username}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No users available
                          </option>
                        )}
                      </select>
                      <button onClick={handleinactive} className="create">
                        Active
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* USER */}
            {UserDashboard && (
              <div
                className="popup-overlay"
                onClick={() => setUserDashboard(false)}
              >
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <h2 className="HeaderNew">
                    <RiUser3Fill /> USER DASHBOARD
                  </h2>
                  <div className="full-logo">
                    <div className="icon-container">
                      <div className="newlog">
                        <FaUserPlus onClick={() => setPopupvalue("Adduser")} />
                        {/* <div className="ClientName">Client</div> */}
                      </div>
                      <div className="label">CREATE NEW</div>
                    </div>

                    <div>
                      <div className="Vline"></div>
                    </div>
                    <div>
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserPen
                            onClick={() => setPopupvalue("userpassword")}
                          />
                        </div>

                        <div className="label">CHANGE PASSWORD</div>
                      </div>
                      <br />
                      <br />
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserCheck
                            onClick={() => setPopupvalue("userActive")}
                          />
                        </div>
                        <div className="label">ACTIVE USER</div>
                      </div>
                    </div>

                    <div>
                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserGear
                            onClick={() => setPopupvalue("userupdate")}
                          />
                        </div>

                        <div className="label">UPDATE USER</div>
                      </div>

                      <br />
                      <br />

                      <div className="icon-container">
                        <div className="newlog">
                          <FaUserXmark
                            onClick={() => setPopupvalue("userinactive")}
                          />
                        </div>
                        <div className="label">INACTIVE USER</div>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div>
                    <button
                      className="close-btn"
                      onClick={() => setUserDashboard(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "Adduser" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">Name: </span>
                      <input
                        type="text"
                        value={clientdetails.clientname}
                        placeholder="Enter Name"
                        required
                        onChange={(e) =>
                          setClientdetails((prevUser) => ({
                            ...prevUser,
                            clientname: e.target.value,
                          }))
                        }
                        className="Name"
                      />
                      <span className="cname">User Name: </span>
                      <input
                        type="text"
                        value={clientdetails.username}
                        placeholder="Enter username"
                        required
                        onChange={(e) =>
                          setClientdetails((prevUser) => ({
                            ...prevUser,
                            username: e.target.value,
                          }))
                        }
                        className="Name"
                      />
                      <span className="cname">Password: </span>
                      <input
                        type="password"
                        value={clientdetails.password}
                        placeholder="Enter Password"
                        required
                        onChange={(e) =>
                          setClientdetails((prevUser) => ({
                            ...prevUser,
                            password: e.target.value,
                          }))
                        }
                        className="Name"
                      />
                      <button
                        onClick={() => handleCreate("HR")}
                        className="create"
                      >
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "userpassword" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">User Name: </span>

                      <select
                        value={userpassword?.username}
                        className="ds1"
                        onChange={(e) =>
                          setuserpassword((prev) => ({
                            ...prev,
                            username: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled selected>
                          choose HR
                        </option>
                        {hruser.map((row) => {
                          return (
                            <option value={row?.id}>{row?.user_id}</option>
                          );
                        })}
                      </select>

                      <span className="cname">New Password: </span>
                      <input
                        type="password"
                        value={userpassword.newpassword}
                        placeholder="New password"
                        required
                        onChange={(e) =>
                          setuserpassword((prev) => ({
                            ...prev,
                            newpassword: e.target.value,
                          }))
                        }
                        className="Name"
                      />
                      <span className="cname">Confirm Password: </span>
                      <input
                        type="password"
                        value={userpassword.confirmpassword}
                        placeholder="Confirm Password"
                        required
                        onChange={(e) => {
                          setuserpassword((prev) => ({
                            ...prev,
                            confirmpassword: e.target.value,
                          }));
                          if (userpassword.newpassword === e.target.value) {
                            seterror((prev) => ({
                              ...prev,
                              confirmpassword: "",
                            }));
                          }
                        }}
                        className="Name"
                      />

                      {error.confirmpassword ? (
                        <p>{error.confirmpassword} </p>
                      ) : null}
                      <button
                        onClick={() => handleuserpassword()}
                        className="create"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "userupdate" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">HR ID: </span>

                      <select
                        value={userupdate?.hr}
                        className="ds1"
                        onChange={(e) =>
                          setUserupdate((prev) => ({
                            ...prev,
                            hr: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled selected>
                          Choose HR
                        </option>
                        {hruser.map((row) => {
                          return (
                            <option value={row?.id}>{row?.user_id}</option>
                          );
                        })}
                      </select>

                      <span className="cname">User Name: </span>
                      <input
                        type="text"
                        value={userupdate?.username}
                        placeholder="Enter Name"
                        required
                        onChange={(e) =>
                          setUserupdate((prev) => ({
                            ...prev,
                            username: e.target.value,
                          }))
                        }
                        className="Name"
                      />

                      <button onClick={handleUserUpdate} className="create">
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "userActive" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>
                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">HR ID: </span>

                      <select
                        value={active?.user}
                        className="ds1"
                        onChange={(e) =>
                          setactive((prev) => ({
                            ...prev,
                            user: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled>
                          Choose HR
                        </option>
                        {hruser.map((row) => (
                          <option key={row?.id} value={row?.id}>
                            {row?.user_id}
                          </option>
                        ))}
                      </select>

                      {/* <select value={userupdate?.hr} className='ds1' onChange={(e) => setUserupdate(prev => ({ ...prev, hr: e.target.value }))}>
                        <option value="" disabled selected>Choose HR</option>
                        {
                          hruser.map(row => {
                            return <option value={row?.id} >{row?.user_id}</option>
                          })
                        }
                      </select> */}

                      {/* <span className='cname'>User Name: </span>
                      <input
                        type="text"
                        value={userupdate?.username}
                        placeholder="Enter Name"
                        required
                        onChange={(e) => setUserupdate(prev => ({ ...prev, username: e.target.value }))}
                        className='Name'
                      /> */}

                      <button onClick={handleactive} className="create">
                        Inactive
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {popupvalue === "userinactive" && (
              <div className="popup-overlay" onClick={() => setPopupvalue("")}>
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="back">
                    <button
                      type="submit"
                      className="back_button"
                      onClick={() => setPopupvalue("")}
                    >
                      {" "}
                      <span>
                        <FaBackspace />
                      </span>
                      Back{" "}
                    </button>
                  </div>

                  <div className="CC">
                    <div className="form_container">
                      <span className="cname">HR ID: </span>
                      <select
                        value={inactive?.user}
                        className="ds1"
                        onChange={(e) =>
                          setinactive((prev) => ({
                            ...prev,
                            user: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled>
                          Choose HR
                        </option>
                        {Array.isArray(inactiveuser) &&
                        inactiveuser.length > 0 ? (
                          inactiveuser.map((row) => (
                            <option key={row?.id} value={row?.id}>
                              {row?.user_id}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No HR available
                          </option>
                        )}
                      </select>
                      <button onClick={handleinactive} className="create">
                        Active
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* reposrts */}
            {reports && (
              <div
                className="popup-overlay"
                onClick={() => setreports(false)}
              >
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <h2 className="HeaderNew">
                    <LuNotebookPen /> REPORTS
                  </h2>

                  <div className="reports">
                    <div className="form-group">
                      <label htmlFor="year">Year</label>
                      <select
                        id="year"
                        className="form-control"
                        value={results?.year}
                        onChange={(e) =>
                          setresults((prevUser) => ({
                            ...prevUser,
                            year: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled>
                          Select Year
                        </option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="month">Month</label>
                      <select
                        id="month"
                        className="form-control"
                        value={results?.month}
                        onChange={(e) =>
                          setresults((prevUser) => ({
                            ...prevUser,
                            month: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled>
                          Select Month
                        </option>
                        {months.map((month, index) => (
                          <option key={index} value={month}>
                            {month}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="track">
                    <button onClick={handleTrack} className="track-btn">
                      Track
                    </button>
                  </div>

                  {Results && chartData.length > 0 && (
                    <>
                      <div style={{}} className="piechartcontainer">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#f5f5f5",
                            // padding: "20px",
                            // width: "40%",
                            borderRadius: "16px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <PieChart width={250} height={250}>
                            <Pie
                              data={chartData}
                              cx={120}
                              cy={120}
                              outerRadius={80}
                              fill="#8884d8"
                              dataKey="value"
                              label={({ value }) => `${value}`}
                            >
                              {chartData.map((entry, i) => (
                                <Cell
                                  key={`cell-${i}`}
                                  fill={COLORS[i % COLORS.length]}
                                />
                              ))}
                            </Pie>
                            <Tooltip />
                          </PieChart>
                          <div style={{ marginLeft: "20px" }}>
                            {chartData.map((entry, i) => (
                              <p key={i} style={{ color: COLORS[i] }}>
                                {entry.name}: {entry.value}
                              </p>
                            ))}
                          </div>
                        </div>
                      </div>

                      <br />
                      {/* PENDING CLIENTS */}
                      <div>
                        <button
                          onClick={() => {
                            setIsOpen(!isOpen);
                            setIsOpen1(false);
                          }}
                          style={{
                            padding: isOpen ? "15px" : "10px",
                            borderRadius: "20px",
                            marginTop: "10px",
                          }}
                          className="closed"
                        >
                          <span className="closed-content">
                            PENDING CLIENTS
                          </span>
                        </button>

                        <motion.div
                          initial={{ height: "auto", opacity: 1 }}
                          animate={{
                            border: "none",
                            height: isOpen ? "auto" : 0,
                            opacity: isOpen ? 1 : 0,
                          }}
                          transition={{ duration: 0.5 }}
                          style={{
                            overflow: "hidden",
                            background: "white",
                            padding: isOpen ? "15px" : "0px",
                          }}
                        >
                          <div className="button-wrapper">
                            <button className="track-btn">Download</button>
                            <div className="hover-buttons">
                              <button
                                className="sub-btn"
                                onClick={() => handlependingdownload("excel")}
                              >
                                Excel
                              </button>
                              <button
                                className="sub-btn"
                                onClick={() => handlependingdownload("pdf")}
                              >
                                PDF
                              </button>
                            </div>
                          </div>

                          {Results && NotUploadclient.length > 0 ? (
                            <div className="table-cont">
                              <table className="custom-table">
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    <th>Client Name</th>
                                    <th>Client Code</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {NotUploadclient.map((user, i) => (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{user.client_name}</td>
                                      <td>{user.client_code}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <p>No records found</p>
                          )}
                        </motion.div>
                      </div>

                      {/* COMPLETED CLIENTS */}
                      <div>
                        <button
                          onClick={() => {
                            setIsOpen1(!isOpen1);
                            setIsOpen(false);
                          }}
                          style={{
                            padding: isOpen1 ? "15px" : "10px",
                            borderRadius: "20px",
                            marginTop: "10px",
                          }}
                          className="closed"
                        >
                          <span className="closed-content">
                            COMPLETED CLIENTS
                          </span>
                        </button>

                        <motion.div
                          initial={{ height: "auto", opacity: 1 }}
                          animate={{
                            height: isOpen1 ? "auto" : 0,
                            border: "none",
                            opacity: isOpen1 ? 1 : 0,
                          }}
                          transition={{ duration: 0.5 }}
                          style={{
                            // overflow: "hidden",

                            background: "white",
                            padding: isOpen1 ? "10px" : "0px",
                          }}
                        >
                          <div className="button-wrapper">
                            <button className="track-btn">Download</button>
                            <div className="hover-buttons">
                              <button
                                className="sub-btn"
                                onClick={() => handlecompletedownload("excel")}
                              >
                                Excel
                              </button>
                              <button
                                className="sub-btn"
                                onClick={() => handlecompletedownload("pdf")}
                              >
                                PDF
                              </button>
                            </div>
                          </div>
                          {Results && Upload1client.length > 0 ? (
                            <div className="table-cont">
                              {Upload1client.map((user, i) => (
                                <div key={i} style={{ margin: "10px" }}>
                                  <button
                                    onClick={() =>
                                      setExpandedClientIndex(
                                        expandedClientIndex === i ? null : i
                                      )
                                    }
                                    style={{
                                      // background: "",
                                      padding: "10px",
                                      borderRadius: "5px",
                                      width: "50%",
                                      textAlign: "left",
                                      color: "black",
                                      fontWeight: "bold",
                                      background: "rgb(168, 101, 101, 0.1)",
                                      border: "none",
                                      // color: "white"
                                    }}
                                  >
                                    {i + 1}. {user.client_name}
                                    <span
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <GoTriangleDown />
                                    </span>
                                  </button>

                                  {expandedClientIndex === i && (
                                    <motion.div
                                      initial={{ height: 0, opacity: 0 }}
                                      animate={{ height: "auto", opacity: 1 }}
                                      transition={{ duration: 0.4 }}
                                      style={{
                                        overflow: "hidden",
                                        background: "#f9f9f9",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        marginTop: "5px",
                                      }}
                                    >
                                      <h2
                                        style={{
                                          color: "#b30101",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        Files details
                                      </h2>
                                      {Uploadclient.filter(
                                        (f) =>
                                          f.client_name === user.client_name
                                      ).length > 0 ? (
                                        <table className="custom-table">
                                          <thead>
                                            <tr>
                                              <th>ID</th>
                                              <th>Act</th>
                                              <th>Form</th>
                                              <th>Type</th>
                                              <th>File</th>
                                              <th>State</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {Uploadclient.filter(
                                              (f) =>
                                                f.client_name ===
                                                user.client_name
                                            ).map((file, j) => (
                                              <tr key={j}>
                                                <td>{j + 1}</td>
                                                <td>{file.act}</td>
                                                <td>{file.forms}</td>
                                                <td>{file.type}</td>
                                                <td>{file.file}</td>
                                                <td>{file.state}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      ) : (
                                        <p>No records found</p>
                                      )}
                                    </motion.div>
                                  )}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p>No records found</p>
                          )}
                        </motion.div>
                      </div>
                    </>
                  )}

                  <br />
                  <div>
                    <button
                      className="close-btn"
                      onClick={() => setreports(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : null}
      </div>

      {showAdditionalComponent && (
        <div className="additional-component">
          <Heading
            selectedState={
              client.find((c) => c.username === listingValues.client)?.state
            }
            selectedTable={selectedTable}
            setSelectedTable={setSelectedTable}
            username={userDetails.username}
            selectedid={listingValues?.client_id}
            selectedname={listingValues.client}
            selectedyear={listingValues.year}
            selectedmonth={listingValues.month}
            selecteddivision={listingValues.division}
          />

          {/* <Table role={userDetails.role}
            username={userDetails.username}
            selectedid={listingValues.client}
            selectedyear={listingValues.year}
            selectedmonth={listingValues.month}
            selecteddivision={listingValues.division}
            // selectedState={listingValues.state}
            // selectedTable={selectedTable}
          /> */}
        </div>
      )}
    </div>
  );
}
export default Admin;
